<template>
  <div class="privacy-container">
    <div class="privacy-content">
      <h1 class="privacy-title">隐私政策</h1>
      <div class="privacy-body">
        <p class="effective-date">生效日期：2026 年 05 月 08 日</p>
        
        <p class="intro">
          本隐私政策适用于节众APP（以下简称 "本应用"），本应用面向企业及运维人员提供能耗监测、设备管理、故障报修、维修派单、工单流转、运维记录等服务。
        </p>
        <p class="intro">
          我们严格依照《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》《电信和互联网用户个人信息保护规定》及各大安卓应用市场上架规范，坚持合法、正当、必要、诚信原则，仅收集实现业务功能所必需的个人信息，保护用户隐私与数据安全。
        </p>

        <section class="section">
          <h2>一、信息收集与使用范围</h2>
          
          <h3>1. 注册登录信息</h3>
          <p>收集手机号、用户姓名、企业单位、部门岗位信息，用于账号注册、实名认证、身份权限划分、维修人员派单匹配。</p>
          
          <h3>2. 业务服务数据</h3>
          <p>收集设备编号、能耗采集数据、设备运行状态、故障信息、维修工单记录、运维日志，仅用于平台能耗统计、设备监测、故障预警、维修派单及工单闭环管理。</p>
          
          <h3>3. 设备权限及相关信息</h3>
          <ul>
            <li><strong>相机 / 相册：</strong>仅在用户授权后，用于拍摄设备故障照片、维修现场照片、工单凭证上传存档；</li>
            <li><strong>定位信息：</strong>仅授权后使用，用于维修人员现场签到、服务区域定位、派单就近分配；</li>
            <li><strong>存储权限：</strong>用于缓存业务数据、保存工单图片、本地日志读取；</li>
            <li><strong>网络权限：</strong>用于数据接口请求、消息推送、云端同步能耗与工单数据；</li>
            <li><strong>设备基础信息：</strong>手机型号、系统版本、设备标识，用于适配兼容、安全风控、异常崩溃日志分析。</li>
          </ul>
          
          <h3>4. 不收集的信息</h3>
          <p>本应用不会主动收集通讯录、短信、通话记录、敏感隐私相册等非必要信息；不会强制申请与业务无关的隐私权限。</p>
        </section>

        <section class="section">
          <h2>二、信息使用目的</h2>
          <ul>
            <li>提供能耗监测、设备管理、故障报修、维修派单、工单处理等核心服务；</li>
            <li>完成账号身份核验、权限管理、账号安全防护；</li>
            <li>进行系统故障排查、应用版本优化、服务体验改进；</li>
            <li>推送工单通知、设备告警、运维业务相关消息；</li>
            <li>履行法律法规及平台服务协议约定义务。</li>
          </ul>
        </section>

        <section class="section">
          <h2>三、信息共享与披露</h2>
          <p>我们不会出售、出租、非法向第三方转让用户任何个人信息；</p>
          <p>仅在以下情形可依规披露：</p>
          <ul>
            <li>经用户本人明确同意或授权；</li>
            <li>国家机关依法依规要求提供；</li>
            <li>委托合规第三方服务商（短信、云服务器、消息推送），且签订保密协议，仅限服务必需使用。</li>
          </ul>
        </section>

        <section class="section">
          <h2>四、信息存储与安全保护</h2>
          <ul>
            <li>用户业务及个人数据仅存储于国内合规云服务器，不跨境传输；</li>
            <li>采用加密传输、权限隔离、访问管控等安全措施，防止信息泄露、篡改、丢失；</li>
            <li>仅业务必要人员可访问数据，遵循最小权限原则；</li>
            <li>用户注销账号后，我们将依规删除或匿名化个人信息。</li>
          </ul>
        </section>

        <section class="section">
          <h2>五、用户权利</h2>
          <ul>
            <li>可在 App 内查看、编辑个人资料及业务信息；</li>
            <li>可随时在手机系统设置关闭定位、相机、存储等权限，关闭后部分功能可能无法正常使用；</li>
            <li>可申请账号注销，注销后停止服务并清理相关个人数据；</li>
            <li>如对隐私政策有疑问，可通过 App 内客服或官方联系方式咨询。</li>
          </ul>
        </section>

        <section class="section">
          <h2>六、未成年人保护</h2>
          <p>本应用定位企业运维办公工具，不面向未成年人提供服务，不主动收集未成年人个人信息；若误收集到未成年人信息，发现后将立即删除。</p>
        </section>

        <section class="section">
          <h2>七、政策更新</h2>
          <p>我们可根据业务及法规变化适时修订本隐私政策，更新后将在 App 内公示，继续使用应用即视为同意新版隐私政策。</p>
        </section>

        <section class="section">
          <h2>八、联系方式</h2>
          <div class="contact-info">
            <p><strong>应用名称：</strong>节众</p>
            <p><strong>客服及隐私咨询邮箱：</strong>jiezhong@sinowyde.com</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {}
  }
}
</script>

<style scoped>
.privacy-container {
  min-height: 100%;
  background-color: #f5f7fa;
  padding: 40px 20px;
}

.privacy-content {
  max-width: 900px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 40px;
}

.privacy-title {
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}

.effective-date {
  text-align: center;
  color: #909399;
  font-size: 14px;
  margin-bottom: 30px;
}

.privacy-body {
  line-height: 1.8;
  color: #606266;
}

.intro {
  text-indent: 2em;
  margin-bottom: 15px;
}

.section {
  margin-bottom: 30px;
}

.section h2 {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.section h3 {
  font-size: 15px;
  font-weight: bold;
  color: #303133;
  margin: 15px 0 10px 0;
}

.section p {
  margin-bottom: 10px;
}

.section ul {
  margin: 10px 0;
  padding-left: 20px;
}

.section li {
  margin-bottom: 8px;
}

.contact-info {
  background-color: #f5f7fa;
  padding: 15px 20px;
  border-radius: 4px;
  margin-top: 10px;
}

.contact-info p {
  margin-bottom: 5px;
}
</style>
